import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { Submenu } from '../../comps/Submenu';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mg } from '../../mg/mg';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'/creationTimestamp :datetime',
	'/timestamp :datetime',
	'*name',
	'email',
	'owner.email',
	'*kind :Supplier_Kind',

	null,
	'addressLine',
	'street',
	'number',
	'zipcode',
	'town',
	'phone',
	'fax',

	null,
	'*industry :Supplier_Industry',
	'allowsOrderMessage :bool',
	'deliveryTiming :Supplier_DeliveryTiming',
	'pickupTiming :Supplier_PickupTiming',
	'pickupLocations',
	'paymentOptions :Supplier_PaymentOptions',
	'isDeleted :bool',
	'orderReferenceLength :nonNegInt',
	'orderHint',
	'nonlistedItemsOrderable :bool',
	'hasMasterCatalog :bool',
	'isHidden :bool',
	'hasCoupon :bool',
	'landingName',

	null,
	'htmlColor :color',
	'imageLink :imageLink',
	'logoLink :imageLink',
	'backgroundImage :imageLink',

	// null,
	// 'partner_invoicePaymentMethod =invoicePaymentMethod [!a@l]hidden w140p0 :list', //TODO
	// 'partner_partnerNoFormatted =PaNo [!a]hidden ro w60p0',//TODO
]);

const dataviewStore = DataviewStore.create({
	id: 'AdmSupplierPage',
	orgColumns: columnist.descriptors,
	filtering: [{columns: ['kind'], type: 'ENUM'}, {columns: ['email']}],
	sorting: {column: 'email'},
});
// 'kind', 'owner_email',
dataviewStore.hideAllButListed('id', 'name', 'email', 'zipcode', 'isDeleted', 'kind');

interface IAdmSupplierDialogProps {
	columnist: MgColumnist
	entity?: object
	onClose() : void
}

const AdmSupplierDialog = observer(function AdmSupplierDialog(props: IAdmSupplierDialogProps) {
	const {columnist, entity, onClose} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, any>;
	const omnistore = useOmnistore();
	const repo = omnistore.multirepo.admSupplierRepo;
	function finish(entity: Record<string, any>) : void {
		if (!entity) return onClose();
		console.log(mg.stringify(entity));
		omnistore.communicator.doPost('AdminUpdateSupplier', entity)
			.then(toasterSvc.handleResponse('saved'))
			.then(r => {
				if (r.outputList) {
					repo.fetch('DIRECT');
					onClose();
				}
			});
	}
	function showPretemplates() {
		const router = omnistore.locationStore;
		router.setPage('AdmPretemplatePage');
		router.setSupplierId(editable.id || 0);
	}
	function showItems() {
		const router = omnistore.locationStore;
		router.setPage('AdmSupplierItemPage');
		router.setSupplierId(editable.id || 0);
	}
	return <MgEntityEditDialog
		columnist={columnist}
		extras={columnist.newExtras(editable, {})}
		entity={editable}
		baseName="AdmSupplierDialog"
		finish={finish}
	>
		{[
			{name: 'items', onClick: showItems},
			editable.kind!=='ONLINE' ? null : {name: 'pretemplates', onClick: showPretemplates},
		]}
	</MgEntityEditDialog>;
});

export const AdmSupplierPage = observer(function AdmSupplierPage() {
	const omnistore = useOmnistore();
	columnist.setExternalGet(omnistore.multirepo.externalGet);
	const repo = omnistore.multirepo.admSupplierRepo;
	React.useEffect(() => {
		repo.fetch();
	}, []);
	useNoSubmenu();
	const onDialogClose = () => dataviewStore.rowClick(0);
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return !repo.etag ? <PleaseWait/> : <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			---
		</Submenu>
		<OcDataview state={dataviewStore} repo={repo}/>
		{!selectedEntity ? null : <AdmSupplierDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose}/>}
	</>;
});
